import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';
import Axios from 'axios';
import config from './Componentes/config';
import useAuthRedirect from "./Componentes/auth";
import './ccss/Prehome.css';

const App = () => {
  useAuthRedirect();
  const [selectedCard, setSelectedCard] = React.useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(['selectedCard']);
  const [EmpresasList, setEmpresas] = useState([]);
  const [deshabilitadasList, setDeshabilitadas] = useState([]);
  const [mostrarDeshabilitadas, setMostrarDeshabilitadas] = useState(false);
  const iduser = cookies.userId;

  // Mapeo de empresas con sus logos y códigos
  const empresasConfig = {
    'DAFA FACILITY SERVICES SPA': {
      logo: '/img/dafaLogo.png',
      codigo: 'DAFA',
      rut: ''
    },
    'FUGAR GESTIÓN Y OBRAS': {
      logo: '/img/fugarLogo.png',
      codigo: 'FUGA',
      rut: ''
    },
    'TRANSPORTES EXTASIS SPA': {
      logo: '/img/extasisLogo.png',
      codigo: 'TRAN',
      rut: ''
    },
    'ITRANSPORTES EXTASIS SPA': {
      logo: '/img/extasisLogo.png',
      codigo: 'TRAN',
      rut: ''
    },
    'GRUPO DE INVERSIONES DAFA SPA': {
      logo: '/img/idafaLogo.png',
      codigo: 'INVE',
      rut: ''
    },
    'NIDIAM SPA': {
      logo: '/img/nidiamLogo.png',
      codigo: 'NIDI',
      rut: ''
    }
  };

  const normalize = (s) => (s || '')
    .toString()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toUpperCase();

  const empresasConfigNorm = Object.keys(empresasConfig).reduce((acc, key) => {
    acc[normalize(key)] = empresasConfig[key];
    return acc;
  }, {});

  const lookupConfig = (nombre) => empresasConfigNorm[normalize(nombre)];

  const handleSelectCard = (ID, cardName, NombreEmpresa) => {
    setSelectedCard(ID);
    setCookie('selectedCard', cardName, { path: '/' });
    setCookie('idEmpresa', ID);
    setCookie('NombreEmpresa', NombreEmpresa);
    console.log("idempresa:" + ID)
    navigate('/home');
  };

  const getTrabajadores = () => {
    Axios.get(`${config.API_URL}/getEmpresas`, {
      params: { iduser } // Envío como parámetro de consulta
    })
      .then(res => {
        console.log(res.data); // Verifica la estructura de la respuesta
        if (Array.isArray(res.data)) {
          // Actualizar los RUTs en la configuración
          const empresasConRut = res.data.map(empresa => {
            const config = lookupConfig(empresa.Nombre_Empresa);
            if (config) {
              config.rut = formatRut(empresa.Rut_Empresa);
              config.id = empresa.ID_Empresa;
            } else {
              console.warn('Empresa sin config en empresasConfig:', JSON.stringify(empresa.Nombre_Empresa));
            }
            return empresa;
          });
          setEmpresas(res.data); // Asegúrate de que sea un array
        } else {
          console.error('La respuesta no es un array:', res.data);
          setEmpresas([]); // Establece un array vacío si no es un array
        }
      })
      .catch(err => {
        console.error("Error al obtener los datos:", err);
      });
  };

  const getDeshabilitadas = () => {
    Axios.get(`${config.API_URL}/getEmpresasDeshabilitadas`, {
      params: { iduser } // Envío como parámetro de consulta
    })
      .then(res => {
        if (Array.isArray(res.data)) {
          setDeshabilitadas(res.data);
        } else {
          console.error('La respuesta no es un array:', res.data);
          setDeshabilitadas([]);
        }
      })
      .catch(err => {
        console.error("Error al obtener las empresas deshabilitadas:", err);
      });
  };

  const handleToggleDeshabilitadas = () => {
    const nuevoValor = !mostrarDeshabilitadas;
    setMostrarDeshabilitadas(nuevoValor);
    if (nuevoValor && deshabilitadasList.length === 0) {
      getDeshabilitadas();
    }
  };

  const formatRut = (rut) => {
    const rutString = rut.toString();
    // Extrae el dígito verificador (último dígito) y los demás números
    const body = rutString.slice(0, -1);
    const verifier = rutString.slice(-1);
    // Aplica puntos cada tres dígitos al cuerpo del RUT
    const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Retorna el RUT formateado con el guion antes del dígito verificador
    return `${formattedBody}-${verifier}`;
  };

  useEffect(() => {
    getTrabajadores();
  }, []);

  const renderEmpresaCard = (empresa, isDeshabilitada = false) => {
    const foundConfig = lookupConfig(empresa.Nombre_Empresa);
    // Las activas mantienen el comportamiento original (se omiten si no hay config).
    // Para las deshabilitadas usamos un fallback genérico para que siempre se muestren.
    if (!foundConfig && !isDeshabilitada) return null;

    const config = foundConfig || {
      logo: '/img/idafaLogo.png',
      codigo: (empresa.Nombre_Empresa || 'EMP').substring(0, 4).toUpperCase(),
    };

    return (
      <div
        key={empresa.ID_Empresa}
        className={`empresa-card empresa-${config.codigo.toLowerCase()} ${hoveredCard === empresa.ID_Empresa ? 'hovered' : ''} ${isDeshabilitada ? 'empresa-deshabilitada' : ''}`}
        onMouseEnter={() => setHoveredCard(empresa.ID_Empresa)}
        onMouseLeave={() => setHoveredCard(null)}
        onClick={() => handleSelectCard(empresa.ID_Empresa, config.codigo, empresa.Nombre_Empresa)}
      >
        <div className="empresa-card-overlay"></div>
        {isDeshabilitada && <span className="empresa-badge-deshabilitada">Deshabilitada</span>}
        <div className="empresa-card-content">
          <div className="empresa-logo">
            <img src={config.logo} alt={empresa.Nombre_Empresa} />
          </div>
          <div className="empresa-info">
            <h3 className="empresa-name">{empresa.Nombre_Empresa}</h3>
            <p className="empresa-rut">{formatRut(empresa.Rut_Empresa)}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid vh-100 d-flex justify-content-center align-items-center prehome-background">
      <div className="empresas-container">
        <h2 className="text-center mb-4 text-white">Selecciona una Empresa</h2>
        <div className="toggle-deshabilitadas">
          <label className="switch">
            <input
              type="checkbox"
              checked={mostrarDeshabilitadas}
              onChange={handleToggleDeshabilitadas}
            />
            <span className="slider"></span>
          </label>
          <span className="toggle-label">Mostrar empresas deshabilitadas</span>
        </div>
        <div className="empresas-grid">
          {EmpresasList.map((empresa) => renderEmpresaCard(empresa, false))}
          {mostrarDeshabilitadas &&
            deshabilitadasList.map((empresa) => renderEmpresaCard(empresa, true))}
        </div>
      </div>
    </div>
  );
}

export default App;